import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';

// SERVICES/SERVICIOS
import { LoadService } from '../../components/loader/loader.service';

// COMPONENTS/COMPONENTES
import { ModalLoginComponent } from '../../components/modals/modal-login/modal-login.component';
import { LoginService, LoginUserRs } from '../../services/login/login.service';
import { UserService } from '@asambleas-services/user/user.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


    // ATTRIBUTES/ATRIBUTOS
    isLoginOpen: boolean = false
    loader: any
    isLoginValidationFailed: boolean = false;

	credential = {
		email: '',
		password: ''
	};

    constructor(
        public dialog: MatDialog,
        private loadService: LoadService,
        private router: Router,
        private loginService: LoginService,
        private _userService: UserService
    ) { }

    ngOnInit() {
    }

    ngAfterViewInit() {
        let isLogged = this.loginService.isLogin()
        if (isLogged) {
            this._userService.currentUser.subscribe((user) => {
                console.log(user)
            })
            this.router.navigate(['/admin']);
        } else {
            this.loginDialog()
        }
    }

    loginDialog() {
        setTimeout(() => {
            const dialogRef = this.dialog.open(ModalLoginComponent, {
                height: 'auto',
                minHeight: '63vh',
                disableClose: true,
                data: {
                    isLoginValidationFailed: this.isLoginValidationFailed
                }
            });

            dialogRef.afterClosed().subscribe(response => {
                this.isLoginOpen = false
                if (response != undefined) {
                    this.loader = this.loadService.createLoad('');
                    this.loader.open()

                    this.credential.email = response.mail
                    this.credential.password = response.password

                    this.loginService.loginUser(this.credential).subscribe((data: LoginUserRs) => {

                        this._userService.createUser(data.user)

                        localStorage.setItem('user', JSON.stringify(data.user))
                        localStorage.setItem('id_token', data.id_token)
                        this.loader.close()
                        this.router.navigate(['/admin']);

                        // PARA AVISAR A APP.COMPONENT QUE SE INGRESÓ AL SITIO
                        this.loginService.ingresoUsuario.emit();

                    }, (error) => {
                        console.log('error', error)
                        this.loader.close()
                        this.isLoginValidationFailed = true;
                        this.loginDialog()
                    })
                }
            });
        }, 1);
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts